
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/p/membership",
      function () {
        return require("private-next-pages/p/membership/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/p/membership"])
      });
    }
  